import { useAuth } from './useAuth';
import { EndpointsMvp } from './enum';
import { addToast } from '../../store/ducks/toast/actions';
import { EToastTypes } from '../../store/ducks/toast/types';
import { useDispatch } from 'react-redux';
import { useApiInstance } from './useApiInstance';
import { GetFlag } from '../../utils/featureFlag';

export interface ProductPricingPayload {
  soldTo: string;
  shipTo: string;
  items: ProductPricingDefinition[];
}

export interface ProductPricingDefinition {
  product?: string;
  quantity?: string;
  um?: string;
  destination?: string;
  paymentTerms?: string;
}

export interface ProductPricingResponse {
  pricing: ProductPricingItemResponse[];
}

export interface ProductPricingItemResponse {
  item: string;
  product: string;
  creditPrice: string;
  um: string;
  paymentTerms: string;
  paymentTermsDescription: string;
  destination: string;
  destinationDescription: string;
  isAgreementPrice: string;
  salesAgreementData: ProductPricingAgreement;
}

export interface ProductPricingAgreement {
  salesAgreement: string;
  expirationDate: string;
  paymentTerms: string;
  paymentTermsDescription: string;
  destination: string;
  agreementUm: string;
}

export const usePricingService = () => {
  const dispatch = useDispatch();
  const { getHeaders } = useAuth();
  const commerceApi = useApiInstance();
  const headers = getHeaders();
  const newSearchItemsEndpointFlag = GetFlag('new_search_items_endpoint');

  const getPricesForSkuList = async ({
    soldTo,
    shipTo,
    items
  }: ProductPricingPayload): Promise<ProductPricingResponse | null> => {
    try {
      const response = await commerceApi.post<ProductPricingResponse>(
        `${EndpointsMvp.PRODUCTS_PRICING}`,
        {
          soldTo,
          shipTo,
          items
        },
        { headers }
      );

      return response.data;
    } catch (error) {
      dispatch(
        addToast({
          type: EToastTypes.DANGER,
          message: 'Falha ao recuperar lista de preços',
          durationInMS: 5000
        })
      );
    }

    return null;
  };

  const getPrice = (product: any) => {
    if (newSearchItemsEndpointFlag) {
      const priceGerdau = product.extension_attributes?.price_gerdau;
      if (priceGerdau) {
        try {
          return JSON.parse(priceGerdau);
        } catch (error) {
          console.error(
            `Error parsing price for product ${product.sku}:`,
            error
          );
          return null;
        }
      }
    } else {
      return product.price;
    }
    return null;
  };

  return {
    getPricesForSkuList,
    getPrice
  };
};
